<template>
    <div>
        <div class="inbox-message message-outbound" style="background: #fffcdc;">
            <div class="message-body">
                <div v-html="note.content"></div>
                <div style="opacity: .6;">Added by {{ note.created_by.name }}</div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        note: {
            type: Object,
            required: true
        }
    }
}
</script>

<style scoped>

</style>